import React from 'react'
import Button from 'ui/buttons/Button'

export default function SubmitButton (props) {
  return (
    <Button {...props} type='submit'>
      {props.children}
    </Button>
  )
}
